/**
 * Hand the browser a JSON file to save.
 *
 * The same six lines existed in `useImportExport` and `CharacterLibrary`
 * before maps needed them a third time - at which point it is a utility
 * rather than a coincidence. The library's files and zips (2026-10-18)
 * hand over bytes that are not JSON: `downloadBlob`.
 *
 * The object URL is revoked immediately after the click: the download has
 * already been handed to the browser by then, and leaving it alive pins
 * the whole blob in memory for the life of the document.
 */
export default function downloadJson(data, filename) {
  downloadBlob(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }), filename);
}

/** Hand the browser any bytes to save: an image, a PDF, a zip. */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Read a picked file as parsed JSON, or reject with something sayable. */
export async function readJsonFile(file) {
  const text = await file.text();
  try {
    return JSON.parse(text);
  } catch {
    throw new Error('That file is not readable JSON.');
  }
}
